import { render } from "./ItemLocations.vue?vue&type=template&id=22150c72&scoped=true"
import script from "./ItemLocations.vue?vue&type=script&lang=js"
export * from "./ItemLocations.vue?vue&type=script&lang=js"

import "./ItemLocations.vue?vue&type=style&index=0&id=22150c72&scoped=true&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22150c72"]])

export default __exports__